import { Trans } from 'react-i18next'
import React from 'react'
import Flex from 'typescript-styled-flex'
import { connect } from 'react-redux'
import { ClickAwayListener } from '@material-ui/core'
import { ModalHeaderLabel } from '../../../../components/Template/Modal'
import { getUpdateReservationFormEvent } from '../../../../reducers/bookingCalendar/selectors/events'
import { is } from '../../../../components/MediaQuery'
import styled from '../../../../theme'
import useSize from '../../../../hooks/useSize'

export const UserSelect = styled.div`
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
`

const UserSelectFlex = styled(Flex as any)`
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
`

const ReservationModalHeader = ({ type, event = null }) => {
  const isDesktop = is.desktop()
  const size = useSize()

  function clearSelection(e) {
    if (
      e &&
      e.target &&
      e.target.className &&
      String(e.target.className).indexOf('text-select') !== -1
    ) {
      return
    }

    try {
      const node = window.getSelection().anchorNode
      if (
        window.getSelection &&
        window.getSelection().anchorNode &&
        node &&
        (String(node.parentElement ? node.parentElement.className : '').indexOf(
          'text-select',
        ) !== -1 ||
          String(
            node.firstChild ? (node.firstChild as any).className : '',
          ).indexOf('text-select') !== -1 ||
          String((node as any).className).indexOf('text-select') !== -1)
      ) {
        window.getSelection().removeAllRanges()
      } else if ((document as any).selection) {
        ;(document as any).selection.empty()
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Please install Firefox 67+')
    }
  }

  return (
    <Flex
      column={!isDesktop}
      full={true}
      justifyCenter={!isDesktop}
      style={{ minWidth: '0' }}
    >
      <ModalHeaderLabel style={{ fontSize: `${16 * size}px` }}>
        {type === 'create' ? (
          <Trans i18nKey={'add_reservation'}>Dodaj rezerwacje</Trans>
        ) : event && event.guest.name ? (
          <Flex column={true} style={{ minWidth: 0 }}>
            <ClickAwayListener onClickAway={clearSelection}>
              <div>
                <UserSelect
                  className={'text-select'}
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {event.guest.name}
                </UserSelect>
                <UserSelect
                  className={'text-select'}
                  style={{
                    fontWeight: 500,
                    marginTop: '5px',
                  }}
                >{`#${event.id}`}</UserSelect>
              </div>
            </ClickAwayListener>
          </Flex>
        ) : (
          <ClickAwayListener onClickAway={clearSelection}>
            <UserSelectFlex wrap={true} className={'text-select'}>{`#${
              event ? event.id : ''
            }`}</UserSelectFlex>
          </ClickAwayListener>
        )}
      </ModalHeaderLabel>
    </Flex>
  )
}

const mapStateToPropsCreate = () => {
  return {
    type: 'create',
  }
}

const mapStateToPropsUpdate = state => {
  return {
    event: getUpdateReservationFormEvent(state),
    type: 'update',
  }
}

export default {
  Create: connect(mapStateToPropsCreate)(ReservationModalHeader),
  Update: connect(mapStateToPropsUpdate)(ReservationModalHeader),
}
